// web/src/routes/auth/ForgotPassword.jsx
// Public page: request a password-reset email.
// NOTE: adjust the `api` import to match how your other routes import the wrapper
// (e.g. '../../lib/api'). It needs api.post(path, body).

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | sending | sent
  const [error, setError] = useState(null);

  async function submit() {
    if (!email.trim()) return;
    setState('sending');
    setError(null);
    try {
      // Backend always returns ok (doesn't leak account existence).
      await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
      setState('sent');
    } catch {
      setError('Something went wrong. Please try again.');
      setState('idle');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1a2b1f] px-4">
      <div className="card w-full max-w-md p-8">
        <h1 className="text-xl font-semibold mb-2 text-ink-900">Reset your password</h1>

        {state === 'sent' ? (
          <>
            <p className="text-ink-600 mb-6">
              If an account exists for that email, a reset link is on its way. The link
              expires in 1 hour.
            </p>
            <Link to="/login" className="btn-primary w-full text-center block">
              Back to sign in
            </Link>
          </>
        ) : (
          <>
            <p className="text-ink-600 mb-6">
              Enter your email and we'll send you a link to set a new password.
            </p>
            <input
              className="input w-full mb-3"
              type="email"
              autoComplete="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && submit()}
            />
            {error && <p className="text-red-600 text-sm mb-3">{error}</p>}
            <button
              className="btn-primary w-full"
              disabled={state === 'sending'}
              onClick={submit}
            >
              {state === 'sending' ? 'Sending…' : 'Send Reset Link'}
            </button>
            <div className="mt-4 text-center">
              <Link to="/login" className="text-sm text-ink-500 underline">
                Back to sign in
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
